import React from 'react';
import {
  CardContent as MUICardContent,
  CardContentProps as MUICardContentProps,
} from '@mui/material';

export const CardContent = (props: MUICardContentProps) => (
  <MUICardContent {...props} />
);
